var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 409.336,
    height: 303.668,
    viewBox: "0 0 409.336 303.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M134.2,123.668s37.346-32.678,83.25-17.117,81.694,86.362,126.042,88.7,85.584-21.785,120.6-.778,41.236,112.038-25.675,121.374S334.156,291.724,305.369,293.28s-98.811,36.568-154.051,21.007S46.282,191.357,134.2,123.668Z",
    transform: "translate(-86.325 -66.624)",
    fill: "#e8f4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(11.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(74.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(49.455)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M430.215,116.723H270.575a2.564,2.564,0,0,1-2.481-3.209L283,56.255a2.564,2.564,0,0,1,2.481-1.918h159.64a2.564,2.564,0,0,1,2.481,3.209L432.7,114.8A2.564,2.564,0,0,1,430.215,116.723Z",
    transform: "translate(-268.01 -54.337)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(20.186 12.249)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 55.548,
    transform: "translate(4.273)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 55.549,
    transform: "translate(0 25.638)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 55.55,
    transform: "translate(23.359 15.953)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 16.665,
    transform: "translate(2.848 8.546)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 16.665,
    transform: "translate(0.57 15.953)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 19.799,
    transform: "translate(68.652)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M390.194,119.513H360.63a.228.228,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.228.228,0,0,1,390.194,119.513Z",
    transform: "translate(-311.84 -81.848)",
    fill: "none",
    stroke: "#84aee5",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M340.808,119.513H311.244a.228.228,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.227.227,0,0,1,340.808,119.513Z",
    transform: "translate(-299.202 -81.848)",
    fill: "none",
    stroke: "#84aee5",
    strokeWidth: 1.148
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M456.547,100.7c-1.515-2.019-7.663-3.487-9.362-5.5-.868-1.031-.868-2.947-.661-4.576a6.3,6.3,0,0,0,1.406-1.132,27,27,0,0,0,1.662-2.932.953.953,0,0,0,.708.295c.807-.024,3.88-4.206,3.087-5.176-.453-.554-1.185-.074-1.729.44.813-1.862,1.386-3.29,1.386-3.29h-.031c.077-.235.148-.471.208-.711,1.219-4.89-1.756-8.854-6.646-8.854s-9.842,3.964-11.061,8.854c-.06.24-.106.476-.147.711h-.031s-.14,1.428-.255,3.29c-.288-.513-.78-.994-1.509-.44-1.276.97-.289,5.152.507,5.176a1.532,1.532,0,0,0,.854-.295,18,18,0,0,0,.2,2.932,3.588,3.588,0,0,0,1.133,1.389,9.952,9.952,0,0,1-2.845,4.319c-2.7,2.019-9.585,3.486-12.107,5.5-2.268,1.816-4.292,7.118-4.676,8.166h40.512C457.29,107.817,457.91,102.515,456.547,100.7Z",
    transform: "translate(-306.045 -58.155)",
    fill: "#8dbcf8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(18.69 41.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M392.888,177.977H233.249a2.564,2.564,0,0,1-2.482-3.209l14.9-57.258a2.564,2.564,0,0,1,2.481-1.918H407.79a2.564,2.564,0,0,1,2.482,3.209l-14.9,57.258A2.564,2.564,0,0,1,392.888,177.977Z",
    transform: "translate(-227.693 -111.318)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M388.869,172.234H229.229a2.564,2.564,0,0,1-2.481-3.209l14.9-57.258a2.564,2.564,0,0,1,2.481-1.918h159.64a2.564,2.564,0,0,1,2.482,3.209l-14.9,57.258A2.565,2.565,0,0,1,388.869,172.234Z",
    transform: "translate(-226.664 -109.848)",
    fill: "#a5c5ff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 79.905,
    transform: "translate(52.661 62.386)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 67.513,
    transform: "translate(30.442 0)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(111.086 11.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M414.184,167.655H378.291a2.26,2.26,0,0,1-2.245-2.991l9.056-36.321a4.086,4.086,0,0,1,3.737-2.991h35.893a2.26,2.26,0,0,1,2.245,2.991l-9.056,36.321A4.086,4.086,0,0,1,414.184,167.655Z",
    transform: "translate(-375.954 -125.352)",
    fill: "#b7deff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(2.964 3.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M397.588,177.312l3.141-12.6-5.15-2.18s-9.6,3.513-10.414,4.361c-.685.711-4.131,8.059-5.228,10.417h17.651Z",
    transform: "translate(-379.937 -138.428)",
    fill: "#023f61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M421.473,177.312c.08-2.358.3-9.707-.033-10.417-.394-.848-8.24-4.361-8.24-4.361l-6.237,2.18-3.141,12.6h17.651Z",
    transform: "translate(-386.049 -138.428)",
    fill: "#023f61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M405.727,178.646l4.92-10.9-10.568.606-1.034,10.3Z",
    transform: "translate(-384.827 -139.761)",
    fill: "#bebecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M402.076,159.274l-2.3,1.454-1.511,3.634-.391,4.966,3.24-1.332,2.515,3.028,3.36-2.786,2.061,1.938,3.115-6.663-.548-4.119-1.3-.606Z",
    transform: "translate(-384.527 -137.469)",
    fill: "#dee0e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(15.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M403.45,146.285a1.465,1.465,0,0,0-2.358-.588c-1.585,1.168.27,5.681,1.418,4.323A5.889,5.889,0,0,0,403.45,146.285Z",
    transform: "translate(-400.479 -134.016)",
    fill: "#fb8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M419.394,146.108s1.506-1.862,2.643-.819-2.6,5.813-3.214,4.537S419.394,146.108,419.394,146.108Z",
    transform: "translate(-405.128 -133.933)",
    fill: "#fb8e74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0.901 16.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M411.524,161.211l1.621-8.6-9.384.813L401.69,161.5s1.641,3.823,3.4,5.519C405.088,167.021,410.545,162.307,411.524,161.211Z",
    transform: "translate(-401.69 -152.611)",
    fill: "#fb8877"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M419.808,138.84c-.349,1.046-1.211,1.307-1.275,1.918a6.025,6.025,0,0,1-1.05,2.789,4.854,4.854,0,0,1-.9.784s-8.051,2.267-12.139-.872a7.01,7.01,0,0,1,.013-2.615c.278-1.409-.406-1.656.388-2.354a2.618,2.618,0,0,0,1.053-2.092,3.316,3.316,0,0,1,.9-2.528c.816-.784,1.547-.523,2.341-1.22,0,0,1.174-1.971,2.725-2.2s4.82-1.046,6.765,1.345,1.049,4.485,1.61,5.232S419.808,138.84,419.808,138.84Z",
    transform: "translate(-401.463 -130.137)",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M404.041,141.8s-3.8,10.464,3.356,11.248c6.322.147,8.567-7.568,9.472-11.525s.346-8.1-4.715-7.963S404.6,139.456,404.041,141.8Z",
    transform: "translate(-401.132 -131.012)",
    fill: "#fba990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M406.05,137.7a1.918,1.918,0,0,1,.034,1.685c-.434.846-1.611,1.171-1.787,2.287s-.693,3.438-1.009,3.539-.092-2.267-.039-3.078a13.717,13.717,0,0,1,2.346-6.3c1.688-2.132,2.73-3.032,5.735-3.521s5.282.775,6.117,2.609-.5,6.5-.5,6.5.2-2.22-.543-2.74-1.358-.906-1.234-1.211-2.378.8-4.878,0-3.308-.438-3.724-.181A1.72,1.72,0,0,0,406.05,137.7Z",
    transform: "translate(-401.155 -130.667)",
    fill: "#713336"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M396.342,166.442c-.06.243-3.492,8.419-3.492,8.419l3.014,1.514-.847,1.7",
    transform: "translate(-383.241 -139.428)",
    fill: "none",
    stroke: "#022755",
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M415.947,166.442c-.06.243-.706,8.419-.706,8.419l-3.77,1.514v1.7",
    transform: "translate(-388.007 -139.428)",
    fill: "none",
    stroke: "#022755",
    strokeWidth: 0.488
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M414.184,167.655H378.291a2.26,2.26,0,0,1-2.245-2.991l9.056-36.321a4.086,4.086,0,0,1,3.737-2.991h35.893a2.26,2.26,0,0,1,2.245,2.991l-9.056,36.321A4.086,4.086,0,0,1,414.184,167.655Z",
    transform: "translate(-264.868 -113.816)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 55.549,
    transform: "translate(24.459 13.673)",
    fill: "none",
    stroke: "#73a5ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 55.549,
    transform: "translate(20.186 39.311)",
    fill: "none",
    stroke: "#73a5ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 55.549,
    transform: "translate(43.545 29.626)",
    fill: "none",
    stroke: "#73a5ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 16.665,
    transform: "translate(23.035 22.219)",
    fill: "none",
    stroke: "#73a5ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 16.665,
    transform: "translate(20.756 29.626)",
    fill: "none",
    stroke: "#73a5ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 19.798,
    transform: "translate(88.839 13.673)",
    fill: "none",
    stroke: "#73a5ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M348.848,176.939H319.284a.228.228,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.228.228,0,0,1,348.848,176.939Z",
    transform: "translate(-250.308 -125.599)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M299.462,176.939H269.9a.228.228,0,0,1-.22-.285L271,171.57a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.229.229,0,0,1,299.462,176.939Z",
    transform: "translate(-237.67 -125.599)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 34.611,
    transform: "translate(114.509 34.896)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(20.399 123.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M391.165,282.108H231.526a2.563,2.563,0,0,1-2.481-3.209l14.9-57.258a2.564,2.564,0,0,1,2.481-1.918h159.64a2.564,2.564,0,0,1,2.481,3.209l-14.9,57.258A2.563,2.563,0,0,1,391.165,282.108Z",
    transform: "translate(-228.961 -219.722)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(20.187 12.249)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 55.549,
    transform: "translate(4.273)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 55.549,
    transform: "translate(0 25.638)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 55.549,
    transform: "translate(23.359 15.953)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 16.665,
    transform: "translate(2.848 8.546)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 16.665,
    transform: "translate(0.569 15.953)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 19.798,
    transform: "translate(68.652)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M351.145,284.9H321.581a.228.228,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.228.228,0,0,1,351.145,284.9Z",
    transform: "translate(-272.791 -247.233)",
    fill: "none",
    stroke: "#84aee5",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M301.759,284.9H272.195a.227.227,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.228.228,0,0,1,301.759,284.9Z",
    transform: "translate(-260.153 -247.233)",
    fill: "none",
    stroke: "#84aee5",
    strokeWidth: 1.148
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M417.5,266.085c-1.515-2.019-7.663-3.487-9.362-5.5-.868-1.031-.868-2.947-.661-4.576a6.3,6.3,0,0,0,1.406-1.132,27,27,0,0,0,1.662-2.932.953.953,0,0,0,.708.295c.807-.025,3.88-4.207,3.087-5.176-.453-.554-1.185-.074-1.729.44.813-1.862,1.385-3.29,1.385-3.29h-.031c.077-.235.148-.471.208-.711,1.219-4.889-1.756-8.853-6.646-8.853s-9.842,3.964-11.061,8.853c-.06.24-.106.476-.147.711h-.031s-.14,1.428-.255,3.29c-.288-.513-.78-.994-1.509-.44-1.276.97-.289,5.152.507,5.176a1.532,1.532,0,0,0,.854-.295,18,18,0,0,0,.2,2.932,3.588,3.588,0,0,0,1.133,1.389,9.952,9.952,0,0,1-2.845,4.319c-2.7,2.019-9.585,3.487-12.107,5.5-2.268,1.816-4.292,7.118-4.676,8.166H418.1C418.241,273.2,418.861,267.9,417.5,266.085Z",
    transform: "translate(-266.996 -223.541)",
    fill: "#8dbcf8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(3.877 199.406)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M368.961,384.708H209.322a2.564,2.564,0,0,1-2.481-3.209l14.9-57.258a2.564,2.564,0,0,1,2.481-1.918h159.64a2.564,2.564,0,0,1,2.481,3.209l-14.9,57.258A2.564,2.564,0,0,1,368.961,384.708Z",
    transform: "translate(-206.757 -322.322)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(20.186 12.249)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 55.549,
    transform: "translate(4.273)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 55.549,
    transform: "translate(0 25.638)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 55.549,
    transform: "translate(23.359 15.953)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 16.665,
    transform: "translate(2.848 8.546)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 16.665,
    transform: "translate(0.57 15.953)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 19.798,
    transform: "translate(68.653)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.445
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M328.94,387.5H299.376a.228.228,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.227.227,0,0,1,328.94,387.5Z",
    transform: "translate(-250.586 -349.833)",
    fill: "none",
    stroke: "#84aee5",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M279.555,387.5H249.991a.228.228,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17h29.564a.228.228,0,0,1,.22.285l-1.323,5.084A.228.228,0,0,1,279.555,387.5Z",
    transform: "translate(-237.948 -349.833)",
    fill: "none",
    stroke: "#84aee5",
    strokeWidth: 1.148
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M395.294,368.685c-1.515-2.019-7.663-3.487-9.362-5.5-.868-1.031-.868-2.947-.661-4.576a6.3,6.3,0,0,0,1.406-1.132,27,27,0,0,0,1.662-2.932.953.953,0,0,0,.708.295c.807-.025,3.88-4.207,3.088-5.176-.453-.554-1.185-.074-1.729.44.813-1.862,1.386-3.29,1.386-3.29h-.031c.077-.235.148-.472.208-.711,1.219-4.89-1.756-8.854-6.646-8.854s-9.842,3.964-11.061,8.854c-.06.24-.106.476-.147.711h-.031s-.14,1.428-.255,3.29c-.288-.513-.78-.994-1.509-.44-1.276.97-.289,5.152.507,5.176a1.532,1.532,0,0,0,.854-.295,18.007,18.007,0,0,0,.2,2.932,3.588,3.588,0,0,0,1.133,1.389,9.951,9.951,0,0,1-2.845,4.319c-2.7,2.019-9.585,3.486-12.107,5.5-2.268,1.816-4.292,7.118-4.676,8.166H395.9C396.037,375.8,396.657,370.5,395.294,368.685Z",
    transform: "translate(-244.792 -326.141)",
    fill: "#8dbcf8"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 28.487,
    transform: "translate(134.164 262.077)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 67.798,
    transform: "translate(37.31 185.733)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 16.522,
    transform: "translate(120.633 185.733)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M459.567,220.1h5.727a2.5,2.5,0,0,1,2.392,3.239l-2.422,7.871",
    transform: "translate(-267.575 -96.758)",
    fill: "none",
    stroke: "#7094d8",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0 17.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(6.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M214.448,82.884h-2.921a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.814,1.814,0,0,1,214.448,82.884Z",
    transform: "translate(-210.489 -77.306)",
    fill: "#bfd9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(4.519 8.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M211.578,94.395h-2.921a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.814,1.814,0,0,1,211.578,94.395Z",
    transform: "translate(-207.619 -88.817)",
    fill: "#edf4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M224.071,94.395H221.15a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.814,1.814,0,0,1,224.071,94.395Z",
    transform: "translate(-210.816 -88.817)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M236.563,94.395h-2.921a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.814,1.814,0,0,1,236.563,94.395Z",
    transform: "translate(-214.013 -88.817)",
    fill: "#edf4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0 17.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M208.642,106.174h-2.921a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.815,1.815,0,0,1,208.642,106.174Z",
    transform: "translate(-202.349 -100.596)",
    fill: "#edf4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M205.505,118.755h-2.921a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328H206.9a1,1,0,0,1,1,1.328l-.728,2.921A1.815,1.815,0,0,1,205.505,118.755Z",
    transform: "translate(-201.546 -103.816)",
    fill: "#edf4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M221.134,106.174h-2.921a1,1,0,0,1-1-1.328l.728-2.921A1.814,1.814,0,0,1,219.6,100.6h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.814,1.814,0,0,1,221.134,106.174Z",
    transform: "translate(-205.546 -100.596)",
    fill: "#edf4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M215.661,128.125H212.74a1,1,0,0,1-1-1.328l.728-2.921a1.814,1.814,0,0,1,1.659-1.328h2.921a1,1,0,0,1,1,1.328l-.728,2.921A1.814,1.814,0,0,1,215.661,128.125Z",
    transform: "translate(-204.145 -106.213)",
    fill: "#bfd9ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(36.075 4.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 1.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M271.426,61.931h0l-.044,0c-.045,0-.088-.009-.133-.011v0c-.3-.019-.6-.033-.914-.033-8.662,0-17.43,6.945-19.737,15.569l-.1.412h0c-.01.043-.018.086-.028.129l-.065.264h.009c-1.9,8.742,3.708,15.7,12.688,15.337,8.189-.332,16.447-6.867,18.9-14.967C284.664,69.845,279.812,62.517,271.426,61.931Zm5.974,16.4c-1.729,5.759-7.631,10.408-13.441,10.592-6.246.2-10.143-4.649-8.855-10.745l.18-.724h-.007c1.662-6.04,7.812-10.888,13.889-10.888.315,0,.621.016.923.042C275.9,67.1,279.238,72.211,277.4,78.333Z",
    transform: "translate(-250.029 -61.887)",
    fill: "#ebedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M270.571,64.767h0a1.765,1.765,0,0,0,1.214,2.271c4.736,1.253,7.263,5.935,5.613,11.433-1.729,5.759-7.631,10.407-13.441,10.591-5.7.181-9.443-3.834-9.08-9.167a1.721,1.721,0,0,0-1.825-1.889h0a3.153,3.153,0,0,0-2.991,2.735c-.515,7.608,4.867,13.325,13.03,12.995,8.189-.332,16.447-6.867,18.9-14.967,2.372-7.82-1.209-14.488-7.939-16.273A3.1,3.1,0,0,0,270.571,64.767Z",
    transform: "translate(-250.027 -62.025)",
    fill: "#a5c5ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(39.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M324.448,59.783h0l-.042,0-.166-.01c-.291-.018-.584-.031-.885-.031-8.76,0-17.634,7.1-19.817,15.863s3.147,15.863,11.908,15.863c.3,0,.6-.013.9-.031l.169-.009.047,0h0c8.341-.563,16.518-7.355,18.666-15.68.012-.046.026-.092.038-.138C337.356,67.212,332.552,60.349,324.448,59.783ZM317.4,86.752l-.044,0q-.277.018-.554.023h0c-.063,0-.127,0-.19,0-6.175,0-9.933-5.006-8.393-11.182s7.794-11.182,13.969-11.182c.063,0,.125,0,.188,0,.184,0,.365.011.545.023l.046,0c5.707.4,9.088,5.24,7.614,11.15-.012.046-.026.092-.038.138A15.377,15.377,0,0,1,317.4,86.752Z",
    transform: "translate(-303.049 -59.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M334.388,83.2A15.67,15.67,0,0,1,323.32,92.08a3.274,3.274,0,0,0-2.517,2.305h0a1.806,1.806,0,0,0,2.22,2.3,22.223,22.223,0,0,0,15.764-12.655,1.831,1.831,0,0,0-1.605-2.786h0A3.237,3.237,0,0,0,334.388,83.2Z",
    transform: "translate(-307.574 -65.242)",
    fill: "#bfd9ff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M265.007,132.912H235.443a.227.227,0,0,1-.22-.285l1.323-5.084a.228.228,0,0,1,.22-.17H266.33a.228.228,0,0,1,.22.285l-1.323,5.084A.228.228,0,0,1,265.007,132.912Z",
    transform: "translate(-210.162 -73.027)",
    fill: "#edf4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(165.494 56.263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 14.864,
    cy: 11.592,
    rx: 14.864,
    ry: 11.592,
    transform: "translate(0 19.677) rotate(-41.445)",
    fill: "#73a5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M472.8,172.546a4.908,4.908,0,0,1-4.488,3.592,2.714,2.714,0,0,1-2.7-3.592,4.908,4.908,0,0,1,4.488-3.592A2.714,2.714,0,0,1,472.8,172.546Z",
    transform: "translate(-434.588 -139.931)",
    fill: "#73a5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M443.082,159.8a1.244,1.244,0,0,1-1.023-.473l-3.392-4.519a1.726,1.726,0,0,1,.569-2.282,1.6,1.6,0,0,1,2.282,0l2.536,3.377,9.059-7.25a1.6,1.6,0,0,1,2.282,0,1.726,1.726,0,0,1-.569,2.282l-10.484,8.392A2.051,2.051,0,0,1,443.082,159.8Z",
    transform: "translate(-427.66 -134.615)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(286.006 41.588)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 55.976,
    cy: 4.7,
    rx: 55.976,
    ry: 4.7,
    transform: "translate(0 252.679)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(1.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M563.231,119.8s-1.424,2.848-2.279,9.116,1.424,42.445,1.424,42.445l24.5-2.563-11.11-47.288Z",
    transform: "translate(-506.706 -112.678)",
    fill: "#024470"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M541.618,325.193l-8.546,42.3,16.665.427s4.273-37.6,2.563-37.6S541.618,325.193,541.618,325.193Z",
    transform: "translate(-499.621 -165.238)",
    fill: "#45242c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(71.908 158.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M593.586,446.226s-6.267,6.552-8.831,7.976c.57,1.139,9.685,1.139,13.1-.57s5.983-5.7,5.983-5.7l-.285,4.273h1.709s1.709-5.983,1.709-7.407-1.709-3.418-1.709-3.418Z",
    transform: "translate(-584.755 -353.716)",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M593.177,331.756l6.267,76.914,7.407-.57s8.546-56.4,5.128-75.775S593.177,331.756,593.177,331.756Z",
    transform: "translate(-586.91 -323.566)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M599.492,437.743s-2.279,5.983-5.412,8.831,4.843,2.848,8.261,0,3.7-4.558,4.843-5.128-.285-4.273-.285-4.273Z",
    transform: "translate(-586.958 -352.639)",
    fill: "#ff8d68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(19.252 160.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M524.038,445.193s-7.282,5.4-10.049,6.374c.37,1.22,9.355,2.755,13.012,1.647s6.857-4.607,6.857-4.607l-1,4.164,1.685.288s2.693-5.608,2.933-7.012-1.109-3.657-1.109-3.657Z",
    transform: "translate(-513.989 -355.551)",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M540.865,331.781l-6.787,76.87,7.4.687s17.931-54.156,17.827-73.826S540.865,331.781,540.865,331.781Z",
    transform: "translate(-519.13 -325.686)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M531.42,437.185s-3.255,5.512-6.823,7.792,4.293,3.625,8.143,1.392,4.418-3.869,5.638-4.238.44-4.26.44-4.26Z",
    transform: "translate(-516.472 -354.219)",
    fill: "#ff8d68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(0 39.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M502.857,168.646l-14.726-2.9s-.223,2.008,1.115,2.455l1.339.446s3.347,8.033,4.909,8.925,10.937,4.761,10.937,4.761l2.451-9.446Z",
    transform: "translate(-488.116 -163.738)",
    fill: "#ff7759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M516.987,179.866s-.142-1-2.113-4.993a41.274,41.274,0,0,1-2.677-6.247s-6.917-2.677-8.033-4.017a4.929,4.929,0,0,0-1.785-1.562,3.533,3.533,0,0,0,.67,4.239c2.008,1.785,3.793,3.124,3.793,3.124s-.223,5.132.446,7.587a6.537,6.537,0,0,0,2.681,3.645Z",
    transform: "translate(-491.654 -163.047)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M542.679,193.715s-9.97,15.953-10.255,14.528S519.6,184.884,519.6,184.884l-6.875,2.346s10.294,32.123,16.846,37.25c0,0,.57.854,2.564.57s17.377-16.238,17.377-16.238Z",
    transform: "translate(-494.415 -168.635)",
    fill: "#ff8d68"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M559.369,171.293s-5.341,2.136-7.905,5.84-9.97,20.51-9.97,20.51a22.86,22.86,0,0,0,13.1,9.685l12.534-23.074Z",
    transform: "translate(-501.776 -125.855)",
    fill: "#e86d5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M553.084,243.769s.427,6.837.427,9.4c0,0-10.255,49.566-10.682,61.1s8.119,35.039,8.119,35.039,36.748-.854,48.712-3.418l1.282-24.784s1.709-43.158,0-55.549-8.973-18.8-8.973-18.8l-2.136-5.983Z",
    transform: "translate(-502.113 -143.636)",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M585.221,167.273s9.614,4.487,12.6,9.187,11.964,30.125,11.964,30.125-10.042,3.632-18.8,3.632c0,0,.854,8.119,1.709,10.682s-2.136,3.632-2.136,3.632-20.937,5.769-36.534,2.35c0,0-1.923-.427-1.923-1.282s.214-2.991.214-2.991-1.5-14.528-1.923-17.092-5.128-9.543-4.7-12.321,7.692-15.668,7.692-15.668,4.914-5.768,7.05-7.264,7.477-1.5,7.477-1.5Z",
    transform: "translate(-502.844 -124.826)",
    fill: "#e86d5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M573.155,153.489c.007.335,1.227,7.586-2.789,12.718-4.017,5.244,11.826,5.02,15.508-.335,3.347-4.8,3.012-5.578,3.012-5.578s-2.677-8.7-1.9-14.392C586.766,140.771,572.932,143.894,573.155,153.489Z",
    transform: "translate(-508.999 -118.73)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M571.254,115.7s-4.619,1.182-7.236,8.274-.872,22.163.872,23.936,7.043,1.1,14.391-1.33c7.763-2.563,10.387-10.634,11.774-15.957C593.712,120.427,584.847,109.937,571.254,115.7Z",
    transform: "translate(-507.198 -111.208)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M562.13,122.764s4.273,10.255,20.51,10.825l3.775,18.125s6.913,3.321,9.614,4.807c0,0,3.133-32.9-4.273-40.878s-20.51-5.983-25.638-1.424S562.13,122.764,562.13,122.764Z",
    transform: "translate(-507.029 -110.228)",
    fill: "#024470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M590.437,166.1l-3.632-3.418s-3.2,9.187-14.528,9.828a7.812,7.812,0,0,1-.641-5.768l-1.923,1.5s-4.059,5.768-3.632,7.477,5.84-1.282,5.84-1.282,6.41,3.845,8.973,4.059S590.01,166.739,590.437,166.1Z",
    transform: "translate(-508.06 -123.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M589.615,140.575s1.713-2.825,3.426-1.784-1.09,7.434-3.426,7.583S588.525,142.211,589.615,140.575Z",
    transform: "translate(-513.751 -117.478)",
    fill: "#ff7759"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 6.552,
    y2: 23.359,
    transform: "translate(79.884 60.964)",
    fill: "none",
    stroke: "#bb524f",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M590.019,193.976a15.447,15.447,0,0,0,6.41,7.477",
    transform: "translate(-514.194 -131.659)",
    fill: "none",
    stroke: "#bb524f",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M600.068,184.307a7.875,7.875,0,0,1,7.692-6.41",
    transform: "translate(-516.765 -127.545)",
    fill: "none",
    stroke: "#bb524f",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M552.613,183.065s-6.98,11.466-6.908,14.172,4.558,10.4,4.558,10.4l5.555,14.528",
    transform: "translate(-502.853 -128.867)",
    fill: "none",
    stroke: "#bb524f",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y1: 8.546,
    x2: 7.477,
    transform: "translate(73.903 93.296)",
    fill: "none",
    stroke: "#bb524f",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(2.468 44.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M500.2,172.153l-8.763-2.509a11.336,11.336,0,0,0,1.356,2.509c.57.57,6.695,2.706,6.695,2.706",
    transform: "translate(-491.433 -169.644)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M493.257,173.016a15.494,15.494,0,0,0,1.282,2.991c.427.427,5.84,1.994,5.84,1.994",
    transform: "translate(-491.9 -170.507)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M504.933,170.145l2.674,2.082,2.027-.516",
    transform: "translate(-494.888 -169.772)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(56.882 23.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M575.567,158.036a13.471,13.471,0,0,0,8.261-6.267",
    transform: "translate(-567.378 -144.077)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M568.907,143.346l-1,5.413,1.851.427",
    transform: "translate(-565.418 -141.922)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M568.867,154.105a8.775,8.775,0,0,0,5.555-1",
    transform: "translate(-565.663 -144.42)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M580.646,146.173a2.635,2.635,0,1,1-2.635-2.635A2.635,2.635,0,0,1,580.646,146.173Z",
    transform: "translate(-567.329 -141.971)",
    fill: "#fa6157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M575.126,142.073a.641.641,0,1,1-.641-.641A.641.641,0,0,1,575.126,142.073Z",
    transform: "translate(-566.937 -141.432)",
    fill: "#024470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M565.842,142.073a.641.641,0,1,1-.641-.641A.641.641,0,0,1,565.842,142.073Z",
    transform: "translate(-564.561 -141.432)",
    fill: "#024470"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M560.157,255.054s11.751,3.632,22.861-1.069",
    transform: "translate(-506.552 -147.016)",
    fill: "none",
    stroke: "#562525",
    strokeWidth: 1.148
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M564.847,260.48s5.982,1.994,15.668-1.709",
    transform: "translate(-507.752 -148.241)",
    fill: "none",
    stroke: "#562525",
    strokeWidth: 1.148
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 26.066,
    height: 34.612,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 33.534, 122.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(59.679 82.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M584.028,270.594s-3.56,3.917-4.629,4.772-8.332,1.5-8.332,1.5-3.2,5.341-4.059,5.128-.641-.854-.641-.854-.214-9.614.427-10.682,11.11-4.059,11.11-4.059l1.282-1.5,4.842,5.7",
    transform: "translate(-566.333 -232.565)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M616.365,221.445c.285.855,2.563,7.549,3.7,10.967s-24.5,21.365-28.487,24.5l-3.133,2.563-4.843-5.7,22.5-22.5-3.276-7.407Z",
    transform: "translate(-570.753 -221.445)",
    fill: "#ff8d68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(0 37.887)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y1: 5.983,
    x2: 1.353,
    transform: "translate(0.784 5.555)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y1: 3.418,
    x2: 1.567,
    transform: "translate(0 2.706)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M566.757,272.362l-.57,11.537h1.851l2.991-5.128",
    transform: "translate(-566.187 -272.362)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 39.026)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 55.976,
    cy: 4.7,
    rx: 55.976,
    ry: 4.7,
    transform: "translate(0 255.241)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(14.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(12.179 175.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M146.006,435.121s1.188-2.545,5.6-1.866,4.92,1.527,5.429,3.732,2.036,4.581,3.054,5.09,4.75,3.054,7.8,3.563,3.393,2.375,2.714,3.223-12.214,1.527-14.759,1.188c0,0-8.652-.17-10.687-.848S145.837,435.969,146.006,435.121Z",
    transform: "translate(-139.563 -365.357)",
    fill: "#2d2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M139.442,352.176a8.356,8.356,0,0,1,6.129-9.384c7.419-2.358,8.823,1.071,11.07,7.479s-1.93,61.149-1.93,61.149-8.544,1.458-10.735.165c0,0-6.509-35.635-6.055-45.414S139.442,352.176,139.442,352.176Z",
    transform: "translate(-137.898 -342.046)",
    fill: "#3d4776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M144.847,432.143s9.67-.848,12.724-1.357l-.17,4.411s-7.634,1.357-12.385.679Z",
    transform: "translate(-139.676 -364.755)",
    fill: "#51598d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M136.506,171.33s-6.108.339-9.84,14.25-6.108,30.876-4.75,35.287,15.947,16.286,21.376,16.286,5.768-4.072,4.75-7.465-11.536-12.554-11.536-12.554,8.483-27.144,8.143-34.269S140.237,171.33,136.506,171.33Z",
    transform: "translate(-121.529 -123.303)",
    fill: "#7e78c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(90.436 18.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M244.081,164.236l-1.013.1,2.27-4.494s5.77-.364,6.7,2.073l-2.647,5.87Z",
    transform: "translate(-243.068 -138.411)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M248.784,146.721s-.225-4.593,1.409-5.246,3.465.618,3.465.618,2.645-.269,3.489.859a5.078,5.078,0,0,1,.775,2.836,2.655,2.655,0,0,1,1.88,1.752,11.2,11.2,0,0,1-.305,4.161s-1.728,2.12-3.725,1.595S248.784,146.721,248.784,146.721Z",
    transform: "translate(-245.371 -133.667)",
    fill: "#ff7759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M244.635,147.809s-.612-6.012.035-6.806,7.271-9.957,7.271-9.957a3.342,3.342,0,0,1,.583,3.342c-.79,1.781-3.909,7.185-3.909,7.185l-.016,4.618A10.144,10.144,0,0,1,244.635,147.809Z",
    transform: "translate(-244.245 -131.046)",
    fill: "#ff7759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M245.081,156.005s-1.583-9.655-.5-10.979,6.373-.552,7.384-.17,3.808,3.985,4.2,5.4-2.249,6.546-3.834,7.68S246,157.856,245.081,156.005Z",
    transform: "translate(-244.201 -134.433)",
    fill: "#ff8d68"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M240.376,167.282l2.036-3.732s4.75-.848,7.125,2.884c.679,1.357.339,1.357.339,1.357l-1.527,3.054Z",
    transform: "translate(-151.943 -121.29)",
    fill: "#dee0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M167.849,113.09s5.02,1.284,7.863,8.992.948,24.085-.948,26.011-7.654,1.191-15.639-1.445c-8.437-2.784-11.287-11.556-12.795-17.341C143.443,118.228,153.077,106.828,167.849,113.09Z",
    transform: "translate(-127.745 -107.943)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M151.231,165.679l4.072-14.589s8.143-2.375,13.232,3.054l1.7,2.375v9.5A54.373,54.373,0,0,1,151.231,165.679Z",
    transform: "translate(-129.13 -117.99)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M135.489,274.925a134.381,134.381,0,0,0,0,38.171c3.054,20.358,9.161,22.394,14.759,22.394s7.125-16.286,8.143-23.411,5.09-31.555-2.545-37.153S139.561,268.817,135.489,274.925Z",
    transform: "translate(-124.755 -148.689)",
    fill: "#3d4776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M164.086,298.989s-6.108-16.286,4.581-23.411,18.831-6.108,21.376,5.6,3.054,51.913-.509,60.056S173.246,336.651,164.086,298.989Z",
    transform: "translate(-131.975 -148.833)",
    fill: "#3d4776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M176.96,112.629a7.343,7.343,0,0,1,.964,6.744c-1.445,3.613-6.744,5.058-6.744,5.058a5.8,5.8,0,0,1,0,5.78l-1.2,1.926s1.686,3.854,1.2,4.817-2.168.723-2.168.723-1.926-5.3-2.65-4.817a7.741,7.741,0,0,0-2.649,5.058c0,2.168.723,3.854.241,5.3s-7.948,1.445-11.079.964-7.948-10.115-9.152-14.451c0,0-1.686-6.021.723-11.079,0,0-.481-4.335,3.613-8.67s17.1-2.89,19.268-1.2c0,0-.241-2.409,2.168-1.926A11.524,11.524,0,0,1,176.96,112.629Z",
    transform: "translate(-127.062 -106.785)",
    fill: "#c53a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M177.369,143.383s-.723-3.131-3.372-1.686.481,8.911,2.65,8.43S177.851,144.587,177.369,143.383Z",
    transform: "translate(-134.697 -115.622)",
    fill: "#ff7759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M148.336,169.112s1.136-3.994,2.154-4.334,13.572-1.7,20.358,2.375c3.054,2.375,2.714,4.072,2.714,4.072S153.307,167.338,148.336,169.112Z",
    transform: "translate(-128.389 -121.501)",
    fill: "#dee0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M141.3,168.793s21.036-1.357,35.966,5.09c6.786,3.393,22.309,18.746,22.309,18.746l12.214-25.447s6.871-2.46,9.585,3.987c0,0-7.719,30.028-14.165,39.528-4.072,3.393-23.5-7.634-23.5-7.634s3.054,39.358,2.036,57c-1.357,3.393-27.822,5.09-32.573,4.75s-21.376-5.768-21.715-6.786,2.375-41.733,1.7-46.484-2.714-28.162-2.036-31.555S134.853,170.15,141.3,168.793Z",
    transform: "translate(-123.949 -122.123)",
    fill: "#7e78c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(38.143 177.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M174.392,436.489s1.188-2.545,5.6-1.866,4.92,1.527,5.429,3.732,2.036,4.581,3.054,5.09,4.75,3.054,7.8,3.563,3.393,2.375,2.714,3.223-12.214,1.527-14.759,1.188c0,0-8.652-.17-10.688-.848S174.222,437.337,174.392,436.489Z",
    transform: "translate(-172.79 -367.939)",
    fill: "#3e3343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M176.46,354.049a8.356,8.356,0,0,1,7.125-8.652c7.634-1.527,8.652,2.036,10.179,8.652s-8.652,60.564-8.652,60.564-8.652.509-10.687-1.018c0,0-2.545-36.135-1.018-45.8S176.46,354.049,176.46,354.049Z",
    transform: "translate(-172.823 -345.046)",
    fill: "#3d4776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M173.973,436.968s6.616,1.866,12.214.848l.509-3.9-12.893-.848Z",
    transform: "translate(-173.049 -367.57)",
    fill: "#51598d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M161.947,303.452s7.125,22.9,12.469,34.1",
    transform: "translate(-131.873 -157.113)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M181.44,355.046a9.051,9.051,0,0,1,8.652,0",
    transform: "translate(-136.861 -170.027)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M180.414,359.032s3.563-2.036,9.67,2.29",
    transform: "translate(-136.598 -171.214)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M144.505,350.967s2.8-2.545,9.161.254",
    transform: "translate(-127.409 -169.001)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M147.241,354.522a7.653,7.653,0,0,1,7.889,1.018",
    transform: "translate(-128.109 -170.012)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 1.527,
    y2: 51.913,
    transform: "translate(27.021 188.581)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M188.166,301.042s5.768,3.393,8.143-2.036",
    transform: "translate(-138.582 -155.975)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M195.918,302.654s2.714,21.036,2.036,34.948",
    transform: "translate(-140.566 -156.909)",
    fill: "none",
    stroke: "#2a2e59",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 2.714,
    y2: 29.179,
    transform: "translate(7.172 66.689)",
    fill: "none",
    stroke: "#524b81",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M193.752,210.089s20.1,14.5,29.519,11.706",
    transform: "translate(-140.012 -133.221)",
    fill: "none",
    stroke: "#524b81",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M225.9,205.3a8.393,8.393,0,0,1,3.817,7.634",
    transform: "translate(-148.238 -131.996)",
    fill: "none",
    stroke: "#524b81",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M224.531,202.5a6.126,6.126,0,0,1,6.871,3.054",
    transform: "translate(-147.888 -131.236)",
    fill: "none",
    stroke: "#524b81",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M190.658,178.968s-10.687,5.6-3.563,18.576",
    transform: "translate(-137.681 -125.257)",
    fill: "none",
    stroke: "#524b81",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M172.378,156.226s1.781,4.581,7.762,3.817",
    transform: "translate(-134.542 -119.437)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M249.781,142.959l1.993-1.781a3.064,3.064,0,0,1,2.142.887",
    transform: "translate(-154.35 -115.587)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M252.973,143.4a32.781,32.781,0,0,1,2.842-1.654s2.587.636,2.969,1.993a3.441,3.441,0,0,1,.085,2.078",
    transform: "translate(-155.167 -115.732)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M257.476,147.275c.127-.042,3.605.17,3.605.17a3.045,3.045,0,0,1,1.23,2.5,12.953,12.953,0,0,1-.587,3.286,4.316,4.316,0,0,1-3.357,1.718",
    transform: "translate(-156.319 -117.145)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M258.866,152.065a2.106,2.106,0,0,1-.127,1.909c-.551,1.23-1.219,4.451-3.621,5.958",
    transform: "translate(-155.715 -118.373)",
    fill: "none",
    stroke: "#e66657",
    strokeWidth: 1.026
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M159.249,121.012c-4.962-2.418-11.324.509-11.324.509a6.594,6.594,0,0,1,4.326-4.453",
    transform: "translate(-128.284 -109.417)",
    fill: "none",
    stroke: "#a03a45",
    strokeWidth: 1.368
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M148.267,125.789s1.272-.127,2.927,2.418",
    transform: "translate(-128.372 -111.648)",
    fill: "none",
    stroke: "#a03a45",
    strokeWidth: 1.368
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M177.678,110.456s6.277,1.018,6.447,7.3",
    transform: "translate(-135.898 -107.725)",
    fill: "none",
    stroke: "#a03a45",
    strokeWidth: 1.368
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.9bd16a1d2f7612a09fe7aaaa6a685543.svg";
export { ForwardRef as ReactComponent };